import { render, staticRenderFns } from "./treasury-rts27-query.pug?vue&type=template&id=29c788bb&scoped=true&lang=pug&external"
import script from "./treasury-rts27-query.js?vue&type=script&lang=js&external"
export * from "./treasury-rts27-query.js?vue&type=script&lang=js&external"
import style0 from "./treasury-rts27-query.scss?vue&type=style&index=0&id=29c788bb&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c788bb",
  null
  
)

export default component.exports